import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0ce1bd21df5329e321a9d1390be1db94.jpg"
          alt="Laboratory Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-900/85 to-navy-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative container-custom py-32 lg:py-40">
        <div className="max-w-4xl">
          {/* DNBio Premium Badge with DNA Icon */}
          <div 
            className="inline-flex items-center gap-2.5 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-8"
            aria-label="DN Bio Research"
          >
            <svg 
              className="w-4 h-4 text-primary-400" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M12 3v18" />
              <path d="M6 6c0 3.5 2.5 6 6 6s6-2.5 6-6" />
              <path d="M6 18c0-3.5 2.5-6 6-6s6 2.5 6 6" />
              <circle cx="6" cy="6" r="1.5" fill="currentColor" />
              <circle cx="18" cy="6" r="1.5" fill="currentColor" />
              <circle cx="6" cy="18" r="1.5" fill="currentColor" />
              <circle cx="18" cy="18" r="1.5" fill="currentColor" />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
            </svg>
            <span className="text-white text-sm font-semibold tracking-wide">DN Bio Research</span>
          </div>
          
          <h1 className="text-white mb-6 text-balance">
            Research Peptide Catalog & Quote-Based Ordering
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 mb-10 leading-relaxed max-w-3xl">
            Browse our catalog of high-purity research compounds. Request quotes for laboratory applications. Third-party tested with COA documentation available.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Link
              to="/shop"
              className="btn btn-primary btn-lg"
            >
              Browse Research Catalog
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/contact"
              className="btn btn-lg bg-white text-navy-900 hover:bg-gray-100 focus-visible:ring-white"
            >
              Request Quote
              <i className="ri-file-list-3-line ml-2"></i>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-flask-line', text: 'Research Grade' },
              { icon: 'ri-microscope-line', text: 'HPLC Verified' },
              { icon: 'ri-file-list-3-line', text: 'COA Available' },
              { icon: 'ri-building-line', text: 'B2B Supply' },
            ].map((badge, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center p-5 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 hover:bg-white/10 transition-colors"
              >
                <div className="w-10 h-10 flex items-center justify-center mb-3">
                  <i className={`${badge.icon} text-2xl text-primary-400`}></i>
                </div>
                <span className="text-sm font-semibold text-white">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-white/50"></i>
      </div>
    </section>
  );
}